import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../axiosapi';
import { useModuleContext } from '../../../context/ModuleProvider';
import PollCard from '../../Discussion/PollCard';
import { useAuthContext } from '../../../context/AuthContextProvider';
import bootbox from 'bootbox';
import Nodata from '../../ui/Nodata';

const PollTab = () => {
  const [poll, setPoll] = useState([]);
  let { url } = useModuleContext();
  const { currentUser } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);

  const getPoll = async () => {
    setIsLoading(true);
    await axiosInstance({
      method: 'get',
      url: `${url}/poll?recent=1`,
    })
      .then((res) => {
        setIsLoading(false);
        setPoll(res.data.poll);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
      });
  };

  useEffect(() => {
    getPoll();
  }, []);

  const votePoll = (pollId, pollOptionId) => {
    let data = { pollId, pollOptionId };
    axiosInstance({
      method: 'post',
      url: `${url}/poll/vote`,

      data,
    }).then((res) => {
      let newPoll = poll.map((p) => {
        if (p.id === pollId) {
          p = res.data.poll;
        }
        return p;
      });
      setPoll(newPoll);
    });
  };

  const deletePoll = (e, pollId) => {
    e.preventDefault();
    axiosInstance({
      method: 'delete',
      url: `${url}/poll/${pollId}`,
    }).then((res) => {
      let newPoll = poll.filter((p) => p.id !== pollId);
      setPoll(newPoll);
      bootbox.alert('Poll deleted successfully.');
    });
  };

  return (
    <>
      {isLoading ? (
        Array.from({ length: 3 }).map((_, index) => <SkeletonLoader key={index} />)
      ) : poll && poll.length !== 0 ? (
        poll.map((p) => (
          <PollCard key={p.id} poll={p} votePoll={votePoll} userId={currentUser.id} deletePoll={deletePoll} />
        ))
      ) : (
        <Nodata title="You have not posted the poll yet." src="/images/noComment.jpg" />
      )}
    </>
  );
};

function SkeletonLoader() {
  return (
    <div className="qa-card-skeleton w-100">
      <div className="header">
        <div className="skeleton avatar" />
        <div className="user-info">
          <div className="skeleton name" />
          <div className="skeleton date" />
        </div>
        <div className="skeleton tag" />
      </div>
      <div className="skeleton title" />
      <div className="skeleton message" />
      <div className="skeleton message" />
      <div className="skeleton message" />
      <div className="skeleton message" />
    </div>
  );
}

export default PollTab;
